import React from 'react';
import DefaultLayout from '../../../layout/DefautlLayout';
import Header from '../../../components/header/Header';
import styled from './style.module.css';

import { Link } from 'react-router-dom';

const DermalFillerPage = () => {
	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<div
								className={`section mcb-section bg-cover`}
								style={{
									paddingTop: '0px',
									paddingBottom: '0px',
									backgroundImage: 'url(/assets/images/banners/treatment-xl-2.png)',
									backgroundRepeat: 'no-repeat',
									backgroundPosition: 'right bottom',
								}}>
								<div className="section_wrapper mcb-section-inner">
									<div
										className="wrap mcb-wrap one valign-top clearfix"
										style={{
											padding: '30% 0 10%',
										}}>
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-second column_column">
												<div className={`clearfix ${styled.bannerTextWidth}`}>
													<h2>Dermal & Lip Filler</h2>
													<hr
														className="no_line"
														style={{
															margin: '0 auto 15px',
														}}
													/>
													<p>
														Filler can be used for several purposes; whether it is to plump the lips or under-eyes (tear trough),
														contour the cheekbones or jawline, define the nose, or to fill folds on the face. Some fillers also have
														lifting properties.
													</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className={styled.pusherDiv}></div>

							<div className="section center bg-theme hrmargin_b_60" style={{ paddingTop: '30px', paddingBottom: '15px' }}>
								<div className="section_wrapper clearfix">
									<div className="items_group clearfix">
										<div className="column_attr">
											<h3 className="text-light" style={{ letterSpacing: '3px' }}>
												“ Life is short, get the lips! ”
											</h3>
										</div>
									</div>
								</div>
							</div>

							<div
								className="section mcb-section"
								id="image"
								style={{
									paddingBottom: '70px',
								}}>
								<div className="section_wrapper mcb-section-inner">
									<div className="wrap mcb-wrap one valign-top clearfix">
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<p>
														Certainly, there has been a huge rise in the past few years in dermal and lip filler. The filler used
														nowadays is hyaluronic acid, which is a natural sugar found in the body. This certainly reduces the
														risks of reactions to the product. 80% of the results are visible immediately after treatment, whereas
														the full result can be seen in a week. Lip filler can last 6-9 months, whereas dermal filler can last
														9-12 months. At Sitara Medical Clinic, we prefer the Restylane and Teosyal filler range.
													</p>
												</div>
											</div>

											{/* <div className="column mcb-column one-third column_image">
                                                <div className="image_frame image_item scale-with-grid aligncenter has_border">
                                                    <div className="image_wrapper">
                                                        <div className="mask"></div>
                                                        <img className="scale-with-grid" src="/assets/images/courses/image-1.jpg" alt="home_betheme_blog_masonry_1" width="960" height="960" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="column mcb-column two-third column_column">
                                                <div className="column_attr clearfix">
                                                    <h4>
                                                        WHAT ARE ANTI-WRINKLE INJECTIONS?
                                                    </h4>
                                                    <p>
                                                        
                                                    </p>
                                                    <h4>
                                                        Why choose Sitara Clinic for Anti-Wrinkle injections?
                                                    </h4>
                                                    <ul>
                                                        <li>
                                                            
                                                        </li>
                                                    </ul>

                                                </div>
                                            </div> */}
											{/* <div className="column mcb-column one column_divider">
                                                <hr className="no_line" />
                                            </div> */}

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<div className="column one column_pricing_item">
														<div className="pricing-box custom-pricing-box pricing-box-table pricing-box-featured">
															<div className="plan-header">
																<h3>Pricing</h3>
															</div>

															<div className="plan-inside clearfix">
																<hr className="bg-theme" />
																<ul>
																	<li className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																		<div>
																			<strong>0.5 ml Dermal Filler</strong>
																		</div>
																		<div>
																			Dr Sana - €250/£170 <br />
																			Injectors - €250/£170
																		</div>
																	</li>
																	<li className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																		<div>
																			<strong>1ml Dermal Filler</strong>
																		</div>
																		<div>
																			Dr Sana - €375/£320 <br />
																			Injectors - €310/£270
																		</div>
																	</li>
																	<li className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																		<div>
																			<strong>2ml Dermal Filler</strong>
																		</div>
																		<div>
																			Dr Sana - €600/£515 <br />
																			Injectors - €600/£515
																		</div>
																	</li>
																	<li className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																		<div>
																			<strong>5ml Dermal Filler</strong>
																		</div>
																		<div>
																			Dr Sana - €1200/£1030 <br />
																			Injectors - €1200
																		</div>
																	</li>
																	<li className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																		<div>
																			<strong>Tear trough filler</strong>
																		</div>
																		<div>
																			Dr Sana - €375/£320 <br />
																			Injectors - €310/£270
																		</div>
																	</li>
																	<li className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																		<div>
																			<strong>
																				Non-Surgical Rhinoplasty
																				<br /> (Nose Filler)
																			</strong>
																		</div>
																		<div>
																			Dr Sana - €450-€600/£515 <br />
																			Injectors - N/A
																		</div>
																	</li>
																</ul>
																<hr className="bg-theme" />
															</div>

															<div className="plan-footer">
																<Link to="/book-now" className="button  button_left button_theme button_js">
																	<span className="button_icon">
																		<i className="icon-basket"></i>
																	</span>
																	<span className="button_label">BOOK NOW</span>
																</Link>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column one column_slider">
												<div className="column_attr clearfix hrmargin_b_60">
													<h2
														className="hrmargin_b_60"
														style={{
															textAlign: 'center',
														}}>
														Results
													</h2>

													<div className="content_slider">
														<ul className="content_slider_ul">
															<li className="content_slider_li_1">
																<img
																	width="100%"
																	height="auto"
																	src="/assets/images/treatments/slider/lip-filler-1.jpg"
																	alt="Dermal Lip Filler"
																	className="scale-with-grid wp-post-image"
																/>
															</li>
														</ul>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<h2
														className="hrmargin_b_60"
														style={{
															textAlign: 'center',
														}}>
														After-Care
													</h2>
													<ul>
														<li>
															After treatment, avoid extreme facial expression, alcohol consumption and applying make up for 12
															hours.
														</li>
														<li>
															Please avoid sun exposure, UV light, freezing temperatures, saunas and steam rooms for 2 weeks after
															treatment.
														</li>
														<li>
															It is advisable to avoid strenuous activity or exercise for upto 24 hours and to avoid massaging the
															treated area.
														</li>
														<li>Try to sleep with the head elevated and avoid sleeping on injected areas for one or two days.</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default DermalFillerPage;
